module.exports = __webpack_public_path__ + "static/media/pdf-download.d452c1ec.svg";